// extracted by mini-css-extract-plugin
export var wrapper = "RoundedSquare-module--wrapper--79zly";
export var bigSquare = "RoundedSquare-module--bigSquare--W+zOV";
export var smallSquare = "RoundedSquare-module--smallSquare--UWOMf";